import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useExperimentEnrollment } from './useExperimentEnrollment.tsx';

export const useFireExposureEvents = ({
	skip,
	experimentName,
	extraAnalytics,
}: {
	skip: boolean;
	experimentName: string;
	extraAnalytics: object;
}) => {
	const { cohort } = useExperimentEnrollment({ experimentName, skip });
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireExposureEvents = useCallback(() => {
		if (skip) {
			return;
		}
		FeatureGates.manuallyLogExperimentExposure(experimentName);
		fireOperationalAnalytics(createAnalyticsEvent({}), 'jlaFeature exposed', {
			experimentName,
			cohort,
			...extraAnalytics,
		});
	}, [createAnalyticsEvent, cohort, skip, extraAnalytics, experimentName]);

	return { fireExposureEvents };
};
